export default __webpack_public_path__ + "static/media/edit.af35fa39.svg";